import { render, staticRenderFns } from "./AzProductTab.vue?vue&type=template&id=f5eb6ea6&"
import script from "./AzProductTab.vue?vue&type=script&lang=js&"
export * from "./AzProductTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports